// components/Login/Login.jsx
import React, { useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false); // Добавлено
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  const from = location.state?.from?.pathname || '/';

  // При загрузке страницы проверяем saved username
  React.useEffect(() => {
    const savedUsername = localStorage.getItem('remembered_username');
    if (savedUsername) {
      setUsername(savedUsername);
      setRememberMe(true);
    }
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    
    if (!username.trim() || !password.trim() || isSubmitting) {
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const userData = await login(username, password, rememberMe); // Передаем rememberMe
      if (userData) {
        navigate(from, { replace: true });
      }
    } catch (err) {
      console.error('Ошибка входа:', err);
    } finally {
      setIsSubmitting(false);
    }
  }, [username, password, isSubmitting, login, navigate, from, rememberMe]);

  const handleDemoLogin = useCallback(async (demoUsername, demoPassword) => {
    if (isSubmitting) return;
    
    setUsername(demoUsername);
    setPassword(demoPassword);
    
    setIsSubmitting(true);
    try {
      const userData = await login(demoUsername, demoPassword, false); // Демо вход без remember
      if (userData) {
        navigate(from, { replace: true });
      }
    } catch (err) {
      console.error('Ошибка демо-входа:', err);
    } finally {
      setIsSubmitting(false);
    }
  }, [isSubmitting, login, navigate, from]);

  const handleUsernameChange = useCallback((e) => {
    setUsername(e.target.value);
    // Если пользователь меняет username, снимаем remember
    if (rememberMe) {
      setRememberMe(false);
      localStorage.removeItem('remembered_username');
    }
  }, [rememberMe]);

  const handlePasswordChange = useCallback((e) => {
    setPassword(e.target.value);
  }, []);

  const togglePasswordVisibility = useCallback((e) => {
    e.preventDefault();
    setShowPassword(prev => !prev);
  }, []);

  const handleRememberMeChange = useCallback((e) => {
    const isChecked = e.target.checked;
    setRememberMe(isChecked);
    
    if (!isChecked) {
      // Если пользователь снял галочку, удаляем сохраненный username
      localStorage.removeItem('remembered_username');
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-logo">📚</div>
          <h1>Система управления обучением</h1>
          <p>Войдите в свой аккаунт</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Имя пользователя</label>
            <div className="input-icon">
              <input
                type="text"
                id="username"
                value={username}
                onChange={handleUsernameChange}
                placeholder="username"
                required
                disabled={isSubmitting}
                autoComplete="username"
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password">Пароль</label>
            <div className="input-icon">
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="••••••••"
                required
                disabled={isSubmitting}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={togglePasswordVisibility}
                tabIndex="-1"
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          {/* Добавлен чекбокс Remember Me */}
          <div className="form-group remember-me-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={handleRememberMeChange}
                disabled={isSubmitting}
              />
              <span className="checkbox-text">Оставаться авторизованным</span>
            </label>
          </div>

          {error && (
            <div className="error-message">
              <span>⚠️</span> {error}
            </div>
          )}

          <button 
            type="submit" 
            className="login-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <span className="spinner"></span>
            ) : (
              'Войти'
            )}
          </button>

          <div className="login-footer">
            <a href="#" onClick={(e) => e.preventDefault()}>
              Забыли пароль?
            </a>
          </div>
        </form>

      
      </div>
    </div>
  );
};

export default React.memo(Login);